(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-steps"] && !Shopify.designMode) return;
  try {
    
class ContactSteps extends HTMLElement {
  connectedCallback() {
    this.steps = Array.from(this.querySelectorAll('[data-step]'));
    if (!this.steps.length) return;

    this.progressBar = this.querySelector('[data-progress-bar]');
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next-nav]');
    this.summary = this.querySelector('[data-summary]');
    this.fields = {
      name: this.querySelector('[data-field="name"]'),
      email: this.querySelector('[data-field="email"]'),
      product: this.querySelector('[data-field="product"]'),
      size: this.querySelector('[data-field="size"]'),
      quantity: this.querySelector('[data-field="quantity"]'),
      body: this.querySelector('[data-field="body"]')
    };
    this.current = 0;

    this.steps.forEach((step, index) => {
      const okBtn = step.querySelector('[data-next]');
      if (okBtn) okBtn.addEventListener('click', () => this.tryAdvance());

      const input = step.querySelector('[data-answer]');
      if (input) {
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.tryAdvance();
          }
        });
      }

      step.querySelectorAll('[data-tile]').forEach((tile) => {
        tile.addEventListener('click', () => {
          step.querySelectorAll('[data-tile]').forEach((t) => t.classList.remove('is-selected'));
          tile.classList.add('is-selected');
          this.fields.product.value = tile.dataset.value;
          window.setTimeout(() => this.tryAdvance(), 200);
        });
      });
    });

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.current - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.tryAdvance());

    this.render();
  }

  currentAnswerValue() {
    const step = this.steps[this.current];
    if (step.dataset.type === 'tiles') return this.fields.product.value;
    const input = step.querySelector('[data-answer]');
    return input ? input.value.trim() : '';
  }

  syncFieldsFromStep(index) {
    const step = this.steps[index];
    const input = step.querySelector('[data-answer]');
    if (!input) return;
    if (index === 0) this.fields.name.value = input.value;
    if (step.dataset.type === 'email') this.fields.email.value = input.value;
    if (index === 2) this.fields.size.value = input.value;
    if (index === 3) this.fields.quantity.value = input.value;
  }

  tryAdvance() {
    const step = this.steps[this.current];
    const input = step.querySelector('[data-answer]');
    if ('required' in step.dataset && !this.currentAnswerValue()) {
      if (input) input.focus();
      return;
    }
    // type=email and number min=1 carry native constraints — surface them here rather
    // than letting a bad address reach the review step and bounce back after submit.
    if (input && !input.checkValidity()) {
      input.reportValidity();
      return;
    }
    this.syncFieldsFromStep(this.current);
    this.goTo(this.current + 1);
  }

  goTo(index) {
    if (index < 0 || index >= this.steps.length) return;
    this.steps[this.current].classList.remove('is-active');
    this.current = index;
    this.steps[this.current].classList.add('is-active');

    const input = this.steps[this.current].querySelector('[data-answer]');
    if (input) window.setTimeout(() => input.focus(), 50);

    if (this.steps[this.current].dataset.type === 'review') this.renderSummary();

    this.render();
  }

  renderSummary() {
    const rows = [
      ['Name', this.fields.name.value],
      ['Product type', this.fields.product.value],
      ['Size', this.fields.size.value],
      ['Quantity', this.fields.quantity.value],
      ['Email', this.fields.email.value]
    ].filter(([, value]) => value);

    this.summary.innerHTML = rows.map(([label, value]) => `<div><dt>${label}:</dt><dd>${value}</dd></div>`).join('');
    this.fields.body.value = rows.map(([label, value]) => `${label}: ${value}`).join('\n');
  }

  render() {
    const progress = (this.current / (this.steps.length - 1)) * 100;
    this.progressBar.style.width = progress + '%';
    if (this.prevBtn) this.prevBtn.disabled = this.current === 0;
    if (this.nextBtn) this.nextBtn.disabled = this.current === this.steps.length - 1;
  }
}

customElements.define('contact-steps', ContactSteps);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deals-offer"] && !Shopify.designMode) return;
  try {
    
class DealsOfferForm extends HTMLElement {
  connectedCallback() {
    const dropZone = this.querySelector('[data-deal-file-drop]');
    const fileInput = this.querySelector('[data-deal-file-input]');
    const dropText = this.querySelector('[data-deal-file-text]');
    const errorText = this.querySelector('[data-deal-file-error]');
    if (!dropZone || !fileInput || !dropText) return;

    const defaultText = dropText.textContent;
    const maxSizeMb = parseFloat(dropZone.dataset.maxSizeMb) || null;

    const showError = (message) => {
      if (!errorText) return;
      errorText.textContent = message;
      errorText.hidden = !message;
    };

    const validate = (file) => {
      if (!file) return true;
      if (maxSizeMb && file.size > maxSizeMb * 1024 * 1024) {
        showError(`"${file.name}" is too large (max ${maxSizeMb}mb). Choose a smaller file.`);
        return false;
      }
      showError('');
      return true;
    };

    // Same contract as main-product: constraint validation blocks the submit event
    // outright when a required file is missing, so the message lives on `invalid`.
    if (fileInput.required) {
      fileInput.addEventListener('invalid', (e) => {
        e.preventDefault();
        showError('Please upload your artwork before grabbing this deal.');
        dropZone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      fileInput.form?.addEventListener('submit', (e) => {
        if (fileInput.files.length) return;
        e.preventDefault();
        showError('Please upload your artwork before grabbing this deal.');
        dropZone.scrollIntoView({ behavior: 'smooth', block: 'center' });
        fileInput.focus();
      });
    }

    ['dragenter', 'dragover'].forEach((evt) => {
      dropZone.addEventListener(evt, (e) => {
        e.preventDefault();
        dropZone.classList.add('is-dragover');
      });
    });

    ['dragleave', 'drop'].forEach((evt) => {
      dropZone.addEventListener(evt, (e) => {
        e.preventDefault();
        dropZone.classList.remove('is-dragover');
      });
    });

    dropZone.addEventListener('drop', (e) => {
      if (e.dataTransfer.files.length) {
        fileInput.files = e.dataTransfer.files;
        fileInput.dispatchEvent(new Event('change'));
      }
    });

    fileInput.addEventListener('change', () => {
      const file = fileInput.files[0];
      if (file && !validate(file)) {
        fileInput.value = '';
        dropText.textContent = defaultText;
        return;
      }
      dropText.textContent = file ? file.name : defaultText;
    });
  }
}

customElements.define('deals-offer-form', DealsOfferForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class MobileDrawer extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.header__hamburger:not(.mobile-drawer__close)');
    this.panel = this.querySelector('.mobile-drawer');
    this.closeBtn = this.querySelector('.mobile-drawer__close');

    this.toggle.addEventListener('click', () => this.open());
    this.closeBtn.addEventListener('click', () => this.close());
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
      } else if (event.key === 'Tab') {
        this.trapFocus(event);
      }
    });
  }

  focusableElements() {
    return Array.from(
      this.panel.querySelectorAll('a[href], button:not([disabled])')
    );
  }

  trapFocus(event) {
    const focusable = this.focusableElements();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  open() {
    this.panel.hidden = false;
    this.toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    this.closeBtn.focus();
  }

  close() {
    this.panel.hidden = true;
    this.toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    this.toggle.focus();
  }
}

customElements.define('mobile-drawer', MobileDrawer);

document.querySelectorAll('.header__menu-item--mega').forEach((item) => {
  const trigger = item.querySelector('.header__menu-link');
  const setExpanded = (expanded) => trigger.setAttribute('aria-expanded', String(expanded));
  let closeTimer;

  const open = () => {
    clearTimeout(closeTimer);
    item.classList.add('is-open');
    setExpanded(true);
  };
  const scheduleClose = () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      item.classList.remove('is-open');
      setExpanded(false);
    }, 250);
  };

  item.addEventListener('mouseenter', open);
  item.addEventListener('mouseleave', scheduleClose);
  item.addEventListener('focusin', open);
  item.addEventListener('focusout', (event) => {
    if (!item.contains(event.relatedTarget)) scheduleClose();
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openTrigger = document.activeElement.closest('.header__menu-item--mega');
  if (openTrigger) document.activeElement.blur();
});

function escapeHtml(value) {
  const div = document.createElement('div');
  div.textContent = value ?? '';
  return div.innerHTML;
}

class SearchDrawer extends HTMLElement {
  constructor() {
    super();
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.trigger = this.querySelector('[data-search-drawer-trigger]');
    this.panel = this.querySelector('.search-drawer__panel');
    this.input = this.querySelector('.search-drawer__input');
    this.results = this.querySelector('[data-search-results]');
    this.closeBtn = this.querySelector('.search-drawer__close');

    this.trigger.addEventListener('click', (event) => {
      event.preventDefault();
      this.open();
    });
    this.closeBtn.addEventListener('click', () => this.close());
    this.input.addEventListener('input', this.debounce(() => this.handleInput(), 300));
  }

  debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), wait);
    };
  }

  open() {
    this.panel.hidden = false;
    document.body.style.overflow = 'hidden';
    this.input.focus();
    document.addEventListener('keydown', this.handleKeydown);
  }

  close() {
    this.panel.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.handleKeydown);
    this.trigger.focus();
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(this.panel.querySelectorAll('a[href], button:not([disabled]), input'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  async handleInput() {
    const query = this.input.value.trim();
    if (!query) {
      this.results.innerHTML = '';
      return;
    }

    const url = `${window.routes.predictiveSearchUrl}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
    let data;
    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      data = await response.json();
    } catch (error) {
      return;
    }

    this.renderResults((data && data.resources && data.resources.results && data.resources.results.products) || [], query);
  }

  renderResults(products, query) {
    if (!products.length) {
      this.results.innerHTML = '<p class="search-drawer__empty">No products found.</p>';
      return;
    }

    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    const formatPrice = (price) => {
      const value = Number(price).toFixed(2);
      return currency ? `${value} ${currency}` : `$${value}`;
    };

    const items = products
      .map((product) => {
        const image = (product.featured_image && product.featured_image.url) || product.image || '';
        const title = escapeHtml(product.title);
        return `
          <a class="search-drawer__result" href="${product.url}">
            <span class="search-drawer__result-image">${image ? `<img src="${escapeHtml(image)}" alt="${title}" loading="lazy">` : ''}</span>
            <span>
              <span class="search-drawer__result-title">${title}</span>
              <span class="search-drawer__result-price">${formatPrice(product.price)}</span>
            </span>
          </a>
        `;
      })
      .join('');

    const safeQuery = escapeHtml(query);
    const viewAll = `<a class="tertiary-link search-drawer__view-all" href="${window.routes.searchUrl}?q=${encodeURIComponent(query)}">View all results for "${safeQuery}" →</a>`;

    this.results.innerHTML = items + viewAll;
  }
}

customElements.define('search-drawer', SearchDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.querySelectorAll('[data-collection-sort]').forEach((select) => {
  select.addEventListener('change', () => select.form.submit());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductForm extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-product-json]').textContent);
    this.idInput = this.querySelector('[data-product-variant-id]');
    this.priceWrap = this.querySelector('[data-product-price]');
    this.submitBtn = this.querySelector('[data-product-submit]');

    this.optionGroups = Array.from(this.querySelectorAll('[data-option-position]'));
    this.selections = [];
    this.optionGroups.forEach((group) => {
      const position = Number(group.dataset.optionPosition);
      this.selections[position - 1] = this.getGroupValue(group);

      if (group.matches('select')) {
        group.addEventListener('change', () => this.handleOptionChange(group));
      } else {
        group.querySelectorAll('[data-option-value]').forEach((btn) => {
          btn.addEventListener('click', () => {
            group.querySelectorAll('[data-option-value]').forEach((b) => b.classList.remove('is-active'));
            btn.classList.add('is-active');
            this.handleOptionChange(group);
          });
        });
      }
    });
    this.updateAvailability();

    const mainImage = this.closest('.product')?.querySelector('#ProductMainImage');
    this.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (mainImage) mainImage.src = thumb.dataset.imageUrl;
        this.querySelectorAll('[data-product-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    this.setupFileDrop();
    this.setupAreaPricing();
    this.setupPrintProof();
  }

  // One area unit is 0.001 m2. Sizes are quoted in mm, so a WxH in mm converts as
  // (w * h) / 1000 -- 500 x 700mm = 350000 mm2 = 0.35 m2 = 350 units.
  static get UNITS_PER_SQM() {
    return 1000;
  }

  setupAreaPricing() {
    this.areaRoot = this.querySelector('[data-area-pricing]');
    if (!this.areaRoot) return;

    this.areaWidth = this.areaRoot.querySelector('[data-area-width]');
    this.areaHeight = this.areaRoot.querySelector('[data-area-height]');
    this.areaPieces = this.areaRoot.querySelector('[data-area-pieces]');
    this.areaError = this.areaRoot.querySelector('[data-area-error]');
    this.areaSummary = this.areaRoot.querySelector('[data-area-summary]');
    this.areaTotalEl = this.areaRoot.querySelector('[data-area-total]');
    this.areaRateEl = this.areaRoot.querySelector('[data-area-rate]');
    this.areaMinNote = this.areaRoot.querySelector('[data-area-min-note]');
    this.areaMinValue = this.areaRoot.querySelector('[data-area-min-value]');
    this.quantityInput = this.querySelector('[data-product-quantity]');

    this.areaProps = {
      size: this.areaRoot.querySelector('[data-area-prop-size]'),
      area: this.areaRoot.querySelector('[data-area-prop-area]'),
      pieces: this.areaRoot.querySelector('[data-area-prop-pieces]'),
      units: this.areaRoot.querySelector('[data-area-prop-units]'),
    };

    this.areaMaxWidth = Number(this.areaRoot.dataset.maxWidth);
    this.areaMaxHeight = Number(this.areaRoot.dataset.maxHeight);
    this.areaMinChargeCents = Number(this.areaRoot.dataset.minChargeCents) || 0;
    this.areaUnitPriceCents = Number(this.areaRoot.dataset.unitPriceCents) || 0;
    this.areaCurrency = this.areaRoot.dataset.currency || 'AUD';

    [this.areaWidth, this.areaHeight, this.areaPieces].forEach((input) => {
      input.addEventListener('input', () => this.recalculateArea());
    });

    // Nothing is priced until a size exists, so the form must not be submittable yet.
    this.areaValid = false;
    this.recalculateArea();

    this.querySelector('form')?.addEventListener('submit', (e) => {
      if (this.areaValid) return;
      e.preventDefault();
      this.showAreaError('Enter a width and height before adding this to your cart.');
      this.areaRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  // The print proof fee is a second cart line (items[1]) that only belongs in the
  // submission when "Yes" is checked. Fields disabled at submit time are simply
  // excluded from the request, so toggling the fieldset's `disabled` is enough --
  // no need to add/remove the inputs from the DOM.
  setupPrintProof() {
    const radios = Array.from(this.querySelectorAll('[data-proof-radio]'));
    const feeFields = this.querySelector('[data-proof-fee-fields]');
    const feeNote = this.querySelector('[data-proof-fee-note]');
    if (!radios.length || !feeFields) return;

    const sync = () => {
      const wantsProof = radios.some((radio) => radio.checked && radio.value.startsWith('Yes'));
      feeFields.disabled = !wantsProof;
      feeFields.hidden = !wantsProof;
      if (feeNote) feeNote.hidden = !wantsProof;
    };

    radios.forEach((radio) => radio.addEventListener('change', sync));
    sync();
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: this.areaCurrency,
    }).format(cents / 100);
  }

  showAreaError(message) {
    this.areaError.textContent = message;
    this.areaError.hidden = !message;
  }

  setAreaInvalid(message) {
    this.areaValid = false;
    this.showAreaError(message);
    this.areaSummary.hidden = true;
    if (this.quantityInput) this.quantityInput.value = 1;
    this.submitBtn.disabled = true;
  }

  recalculateArea() {
    const width = Number(this.areaWidth.value);
    const height = Number(this.areaHeight.value);
    const pieces = Number(this.areaPieces.value) || 1;

    if (!width || !height) return this.setAreaInvalid('');
    if (width < 10 || height < 10) return this.setAreaInvalid('Minimum size is 10mm on each side.');
    if (width > this.areaMaxWidth) {
      return this.setAreaInvalid(`Width can't exceed ${this.areaMaxWidth}mm — that's the width of our material roll. Try swapping width and height.`);
    }
    if (height > this.areaMaxHeight) {
      return this.setAreaInvalid(`Height can't exceed ${this.areaMaxHeight}mm. Get in touch and we'll quote it as a custom job.`);
    }
    if (pieces < 1) return this.setAreaInvalid('Enter at least one piece.');

    const sqm = ((width * height) / 1000000) * pieces;

    // Round area up to the next whole unit, then apply the minimum charge as a floor on
    // units so the quantity and the price can never disagree.
    let units = Math.ceil(sqm * ProductForm.UNITS_PER_SQM);
    const minUnits = this.areaUnitPriceCents
      ? Math.ceil(this.areaMinChargeCents / this.areaUnitPriceCents)
      : 0;
    const minApplied = units < minUnits;
    if (minApplied) units = minUnits;

    const totalCents = units * this.areaUnitPriceCents;

    this.areaValid = true;
    this.showAreaError('');
    this.areaSummary.hidden = false;
    this.areaMinNote.hidden = !minApplied;
    if (minApplied && this.areaMinValue) {
      // Rounding up to a whole unit can land a cent or two above the nominal minimum, so
      // quote what's actually being charged rather than the configured figure.
      this.areaMinValue.textContent = `${this.formatMoney(totalCents)} applied`;
    }

    this.areaTotalEl.textContent = `${sqm.toFixed(3)} m² (${pieces} × ${width} × ${height}mm)`;
    this.areaRateEl.textContent = `${this.formatMoney(this.areaUnitPriceCents * ProductForm.UNITS_PER_SQM)} / m²`;

    this.areaProps.size.value = `${width} × ${height} mm`;
    this.areaProps.area.value = `${sqm.toFixed(3)} m²`;
    this.areaProps.pieces.value = String(pieces);
    this.areaProps.units.value = String(units);

    if (this.quantityInput) this.quantityInput.value = units;

    this.priceWrap.innerHTML = `<span class="product__price">${this.formatMoney(totalCents)}</span>`;
    this.submitBtn.disabled = false;
    this.submitBtn.textContent = 'Add to cart';
  }

  getGroupValue(group) {
    if (group.matches('select')) return group.value;
    const active = group.querySelector('.is-active');
    return active ? active.dataset.optionValue : group.querySelector('[data-option-value]')?.dataset.optionValue;
  }

  handleOptionChange(group) {
    const position = Number(group.dataset.optionPosition);
    this.selections[position - 1] = this.getGroupValue(group);
    this.updateVariant();
    this.updateAvailability();
  }

  updateVariant() {
    const match = this.variants.find((variant) => variant.options.every((opt, i) => opt === this.selections[i]));

    if (!match) {
      this.submitBtn.disabled = true;
      this.submitBtn.textContent = 'Unavailable';
      return;
    }

    this.idInput.value = match.id;
    this.submitBtn.disabled = !match.available;
    this.submitBtn.textContent = match.available ? 'Add to cart' : 'Sold out';

    // Area-priced products show a computed total, not the variant price (which is the price
    // of a single 0.001 m2 unit). Re-run the calculation against the new variant's rate
    // instead of writing the unit price into the price row.
    if (this.areaRoot) {
      this.areaUnitPriceCents = match.priceCents;
      if (match.available) this.recalculateArea();
      return;
    }

    const priceHtml = match.onSale
      ? `<span class="product__price product__price--sale">${match.priceHtml}</span><span class="product__price-compare">${match.compareAtPriceHtml}</span>`
      : `<span class="product__price">${match.priceHtml}</span>`;
    const perUnitHtml = match.perUnitHtml ? `<span class="product__price-unit">${match.perUnitHtml}</span>` : '';
    this.priceWrap.innerHTML = priceHtml + perUnitHtml;
  }

  updateAvailability() {
    this.optionGroups.forEach((group) => {
      const position = Number(group.dataset.optionPosition);
      const items = group.matches('select')
        ? Array.from(group.options).map((el) => ({ el, value: el.value }))
        : Array.from(group.querySelectorAll('[data-option-value]')).map((el) => ({ el, value: el.dataset.optionValue }));

      items.forEach(({ el, value }) => {
        const candidate = this.selections.slice();
        candidate[position - 1] = value;
        const match = this.variants.find((variant) => variant.options.every((opt, i) => opt === candidate[i]));
        const unavailable = !match || !match.available;

        if (group.matches('select')) {
          el.disabled = unavailable;
        } else {
          el.classList.toggle('is-unavailable', unavailable);
        }
      });
    });
  }

  setupFileDrop() {
    const dropZone = this.querySelector('[data-file-drop]');
    const fileInput = this.querySelector('[data-file-input]');
    const dropText = this.querySelector('[data-file-drop-text]');
    const errorText = this.querySelector('[data-file-error]');
    if (!dropZone || !fileInput || !dropText) return;

    const defaultText = dropText.textContent;
    const maxSizeMb = parseFloat(dropZone.dataset.maxSizeMb) || null;

    const showError = (message) => {
      if (!errorText) return;
      errorText.textContent = message;
      errorText.hidden = !message;
    };

    const validate = (file) => {
      if (!file) return true;
      if (maxSizeMb && file.size > maxSizeMb * 1024 * 1024) {
        showError(`"${file.name}" is too large (max ${maxSizeMb}mb). Choose a smaller file.`);
        return false;
      }
      showError('');
      return true;
    };

    // Artwork-required products: the file input carries `required`, but the native browser
    // bubble is easy to miss on a long form. Take over validation so the message lands in
    // the drop zone itself and the customer is scrolled to it. The `invalid` event (not
    // `submit`) is what actually fires here — native constraint validation blocks the
    // submit event entirely when a required field is empty.
    if (fileInput.required) {
      fileInput.addEventListener('invalid', (e) => {
        e.preventDefault();
        showError('Please upload your artwork before adding this item to your cart.');
        dropZone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      const form = fileInput.form;
      if (form) {
        form.addEventListener('submit', (e) => {
          if (fileInput.files.length) return;
          e.preventDefault();
          showError('Please upload your artwork before adding this item to your cart.');
          dropZone.scrollIntoView({ behavior: 'smooth', block: 'center' });
          fileInput.focus();
        });
      }
    }

    ['dragenter', 'dragover'].forEach((evt) => {
      dropZone.addEventListener(evt, (e) => {
        e.preventDefault();
        dropZone.classList.add('is-dragover');
      });
    });

    ['dragleave', 'drop'].forEach((evt) => {
      dropZone.addEventListener(evt, (e) => {
        e.preventDefault();
        dropZone.classList.remove('is-dragover');
      });
    });

    dropZone.addEventListener('drop', (e) => {
      if (e.dataTransfer.files.length) {
        fileInput.files = e.dataTransfer.files;
        fileInput.dispatchEvent(new Event('change'));
      }
    });

    fileInput.addEventListener('change', () => {
      const file = fileInput.files[0];
      if (file && !validate(file)) {
        fileInput.value = '';
        dropText.textContent = defaultText;
        return;
      }
      dropText.textContent = file ? file.name : defaultText;
    });
  }
}

customElements.define('product-form', ProductForm);

// Size planner link: carry the size the shopper has picked into the planner, in cm.
// Size values read "5cm x 5cm" or "50mm x 50mm".
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-size-check]');
  if (!link) return;
  const active = link.closest('.product__option')?.querySelector('.product__swatch.is-active');
  const match = active && active.dataset.optionValue.match(/([\d.]+)\s*(cm|mm)\s*x\s*([\d.]+)\s*(cm|mm)/i);
  if (!match) return;
  const cm = (n, unit) => Math.round(parseFloat(n) * (unit.toLowerCase() === 'mm' ? 0.1 : 1) * 10) / 10;
  const url = new URL(link.href, location.origin);
  url.searchParams.set('w', cm(match[1], match[2]));
  url.searchParams.set('h', cm(match[3], match[4]));
  link.href = url.pathname + url.search;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-corner-badge"]) return;
  try {
    
class OfferCornerBadge extends HTMLElement {
  connectedCallback() {
    this.closeBtn = this.querySelector('[data-offer-close]');
    this.modal = this.querySelector('[data-offer-modal]');
    this.openBtn = this.querySelector('[data-offer-open]');

    if (!window.sessionStorage.getItem('offer-badge-dismissed')) {
      this.hidden = false;
    }

    this.closeBtn.addEventListener('click', () => {
      this.hidden = true;
      window.sessionStorage.setItem('offer-badge-dismissed', '1');
    });

    if (!this.modal) return;

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    if (this.openBtn) this.openBtn.addEventListener('click', this.open);

    this.modal.querySelectorAll('[data-offer-dismiss]').forEach((el) => {
      el.addEventListener('click', this.close);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.modal.hidden) this.close();
    });

    // Shopify re-renders the page after a customer form submits, so reopen the
    // modal on the way back to show the success message rather than losing it.
    if (this.modal.querySelector('.offer-modal__success, .offer-modal__error')) {
      this.hidden = false;
      this.open();
    }
  }

  open() {
    this.modal.hidden = false;
    document.body.style.overflow = 'hidden';
    const email = this.modal.querySelector('[data-offer-email]');
    if (email) email.focus();
  }

  close() {
    this.modal.hidden = true;
    document.body.style.overflow = '';
    if (this.openBtn) this.openBtn.focus();
  }
}

customElements.define('offer-corner-badge', OfferCornerBadge);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
class VideoCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    this.dots = Array.from(this.querySelectorAll('[data-dot]'));
    this.slides = Array.from(this.querySelectorAll('.video-carousel__slide'));

    if (!this.track) return;

    this.prevBtn?.addEventListener('click', () => this.scrollByCards(-1));
    this.nextBtn?.addEventListener('click', () => this.scrollByCards(1));

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.slides[index]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });

    this.track.addEventListener('scroll', () => this.updateState(), { passive: true });
    this.updateState();

    this.querySelectorAll('[data-play]').forEach((button) => {
      button.addEventListener('click', () => this.playVideo(button));
    });
  }

  scrollByCards(direction) {
    const slide = this.slides[0];
    if (!slide) return;
    const amount = slide.getBoundingClientRect().width + 16;
    this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }

  updateState() {
    this.updateActiveDot();
    this.updateArrows();
  }

  updateActiveDot() {
    if (!this.slides.length) return;
    const trackRect = this.track.getBoundingClientRect();
    let closestIndex = 0;
    let closestDistance = Infinity;

    this.slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - trackRect.left);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === closestIndex));
  }

  updateArrows() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
    if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= maxScroll;
  }

  playVideo(button) {
    const card = button.closest('.video-carousel__card');
    const videoId = card ? card.dataset.youtubeId : null;
    if (!card || !videoId) return;

    const iframe = document.createElement('iframe');
    iframe.className = 'video-carousel__iframe';
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&playsinline=1&rel=0`;
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', 'Video player');

    card.innerHTML = '';
    card.appendChild(iframe);
  }
}

customElements.define('video-carousel', VideoCarousel);

  } catch(e) { console.error(e); }
})();
})();
